import { Injectable } from '@angular/core';
import { AssignmentsApi } from '../api/assignments.api';

@Injectable()
export class AssignmentsService {

    constructor(private assignmentsApi: AssignmentsApi) { }

    getAssignments = (offset: number, limit: number, searchBy: string, userType: string, bid: number, isSupervisorOnly: boolean, unassigned: boolean) => 
        this.assignmentsApi.getAssignments({ offset, limit, searchBy, userType, bid, isSupervisorOnly, unassigned });

    removeBuildingAssignments = (buildingAssignments: { buildingId: number | null, userIds: string[] }) =>
        this.assignmentsApi.removeBuildingAssignments(buildingAssignments);

    addBuildingAssignments = (buildingAssignments: { buildingId: number | null, userIds: string[] }) =>
        this.assignmentsApi.addBuildingAssignments(buildingAssignments);

    addBuildingLeads = (buildingAssignments: { buildingId: number | null, userIds: string[] }) =>
        this.assignmentsApi.addBuildingLeads(buildingAssignments);

    removeBuildingLeads = (buildingAssignments: { buildingId: number | null, userIds: string[] }) =>
        this.assignmentsApi.removeBuildingLeads(buildingAssignments);
}
